export default __webpack_public_path__ + "static/media/promotion_banner.da1ad050.png";